/**
 * Convience functions for keeping track of objects being edited.
 */
export default {
    data () {
        return {
            // Array with IDs of the records that are being edited.
            editing: [],
        };
    },
    methods: {
        isEditing (id) {
            return this.editing.indexOf(id) >= 0;
        },
        async edit (id) {
            const i = this.editing.indexOf(id);
            if (i === -1) {
                this.editing.push(id);
                await this.$nextTick();
            }
            this.$emit('editing');
            return [id, true];
        },
        async unEdit (id) {
            const i = this.editing.indexOf(id);
            if (i >= 0) {
                this.editing.splice(i, 1);
                await this.$nextTick();
            }
            this.$emit('endEditing');
            return [id, false];
        },
    },
};
